import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  entriesSelector, showOnMapSelector,
  pageSelector, viewAllShopsSelector, directionModeSelector,
} from '../../selectors/shops';
import { shopsActions } from '../../actions';
import Store from './Store';
import styles from './StoresList.module.sass';
import Button from '../../../ui_kit/button/Button';

const PER_PAGE = 6;
const STORES_LIST_BLOCK_ID = 'storeslist';
const DESKTOP_WIDTH_BREAKPOINT = 700;
class StoresList extends Component {
  componentDidMount() {
    window.addEventListener('info_window_opened', this.onInfoWindowOpen);
  }

  componentWillUnmount() {
    window.removeEventListener('info_window_opened', this.onInfoWindowOpen);
  }

  onInfoWindowOpen = (event) => {
    const {
      shops, setPage, setActiveStoreId, page,
    } = this.props;
    const incomingShopId = event.detail;
    let neededShopIndex = 0;
    shops.forEach((shop, index) => {
      if (shop.id === incomingShopId) {
        neededShopIndex = index;
      }
    });
    const neededPage = ((neededShopIndex / PER_PAGE) + 1).toFixed();
    setActiveStoreId(incomingShopId);
    if (neededPage > page) { setPage(Number(neededPage)); }
    const storesListOffset = document.getElementById(STORES_LIST_BLOCK_ID).offsetTop;
    const storeOffset = document.getElementById(incomingShopId).offsetTop;
    document.getElementById(STORES_LIST_BLOCK_ID).scrollTo(
      {
        top: storeOffset - storesListOffset,
        behavior: 'smooth',
      },
    );
  };

  loadMore = () => {
    const { incrementPage } = this.props;
    incrementPage();
  };

  showMap = () => {
    const { showOnMap } = this.props;
    const screenWidth = window.screen.width;

    if (screenWidth >= DESKTOP_WIDTH_BREAKPOINT) {
      return false;
    }
    return showOnMap;
  };

  render() {
    const { page, viewAllShops, directionMode } = this.props;
    const { shops } = this.props;
    const isLastPage = (page === Number((shops.length / PER_PAGE).toFixed()));
    const paginatedShops = shops.slice(0, page * PER_PAGE);

    return (
      <div className={styles.stores} id={STORES_LIST_BLOCK_ID}>
        { paginatedShops.length > 0 && !this.showMap() && !viewAllShops && !directionMode && (
          <>
            { paginatedShops.map((shop, index) => (
              <Store number={index} key={shop.id} shop={shop} />
            )) }
            { shops.length > PER_PAGE && !isLastPage && (
              <div className={styles['load-more']}>
                <Button size="small" onClickHandler={this.loadMore} text="SHOW MORE" />
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

StoresList.propTypes = {
  shops: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showOnMap: PropTypes.bool.isRequired,
  page: PropTypes.number.isRequired,
  incrementPage: PropTypes.func.isRequired,
  viewAllShops: PropTypes.bool.isRequired,
  directionMode: PropTypes.bool.isRequired,
  setPage: PropTypes.func.isRequired,
  setActiveStoreId: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  incrementPage: () => { dispatch(shopsActions.incrementPage()); },
  setPage: (page) => { dispatch(shopsActions.setPage(page)); },
  setActiveStoreId: (activeStoreId) => {
    dispatch(shopsActions.setActiveStoreId(activeStoreId));
  },
});

const mapStateToProps = (state) => ({
  shops: entriesSelector(state),
  showOnMap: showOnMapSelector(state),
  page: pageSelector(state),
  viewAllShops: viewAllShopsSelector(state),
  directionMode: directionModeSelector(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoresList);
